import { Dataset } from '../../types/types';

/** Applies a strict screen-only column set without removing print metadata. */
export const selectGridDataset = (
  dataset: Dataset | null | undefined
): Dataset | null | undefined => {
  const itemNames = dataset?.gridItemNames;
  if (
    !dataset ||
    !Array.isArray(dataset.items) ||
    !Array.isArray(itemNames) ||
    itemNames.length === 0
  ) {
    return dataset;
  }

  const allowed = new Set(itemNames);
  return {
    ...dataset,
    items: dataset.items
      .filter((item) => allowed.has(item.name))
      .map((item) => ({ ...item, visible: true })),
  };
};
